<template>
  <div class="content-card__side content-card__side--scroll">
    <div class="content-card__box">
      <div class="content-card__description">{{ memory.description }}</div>
      <div class="content-card__user" v-if="memory.full_name">
        {{ memory.full_name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MemoryCopyWish",
  props: {
    memory: Object
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.content-card {
  &__side--scroll {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__box {
    max-height: 100%;
    overflow-y: auto;
  }

  &__user {
    color: black;
    font-weight: 700;
    font-size: 12px;
    line-height: 1.33;
    margin-top: 0;
  }

  &__description {
    color: black;
    font-weight: 300;
    font-size: 18px;
    line-height: 23px;
    margin-top: 20px;
  }

  &__image {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-size: contain;
    background-position: center;
  }
}

@media screen and (max-width: 960px) {
  .content-card {
    &__description {
      margin: 30px 0;
    }
  }
}
</style>
